import '@babel/polyfill';
import '@babel/plugin-syntax-dynamic-import';
import * as conditioner from 'conditioner-core/conditioner-core.min';

// gsap
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// barba
import barba from '@barba/core';

// lenis
import * as lenis from './modules/lenis'

// fixed sections
import * as fixedSections from './modules/fixedSections'

// clone fields
import * as cloneFields from './modules/cloneFields'

// rellax
import * as rellax from './modules/rellax'

// rellax
import * as obfuscate from './modules/obfuscate'

// marquee size
import * as marqueeSize from './modules/marquee-size'

// vh
import * as vh from './modules/vh'
vh.init();

const app = () => {
    rellax.init();
    lenis.init();
    fixedSections.init();
    cloneFields.init();
    marqueeSize.init();
    obfuscate.init();
}

app();

const initRecaptchas = () => {
    const grecaptchas = document.querySelectorAll('.g-recaptcha');
    grecaptchas.forEach(item => {
        const id = grecaptcha.render(item, {
            'hl' : document.body.dataset.lang
        });
        item.setAttribute('data-id', id);
    });
}

window.recaptchaReady = initRecaptchas;

// barba
const timeline = gsap.timeline();
const barbaWrap = document.querySelector('.barba-wrap');
barba.init({
    cacheIgnore: ['/fr/wishlist'],
    prefetchIgnore: ['/fr/wishlist'],
    timeout: 5000,
    transitions: [
        {
            async leave() {
                timeline.to(barbaWrap, { opacity: '0', duration: 0.5 });
                const done = this.async();
                await delay(500);
                done();
            },

            enter() {
            },
            beforeEnter: ({ next }) => {
                const matches = next.html.match(/<body.+?class="([^""]*)"/i);
                document.body.setAttribute('class', (matches && matches.at(1)) ?? '');
            },
            once() {
                conditioner.hydrate(document.documentElement);
                timeline.to(barbaWrap, { opacity: '1', duration: 0.5 });

                if(window.location.hash) {
                    const strate = document.querySelector(window.location.hash);

                    if (strate) {
                        const stratePosition = strate.getBoundingClientRect().top;
                        const offset = 100;
                        const offsetPosition = stratePosition + window.pageYOffset - offset;

                        window.scrollTo({
                             top: offsetPosition,
                             behavior: "smooth"
                        });
                    }
                }
            }
        }
    ]
});

barba.hooks.after(() => {
    lenis.destroy();
    ScrollTrigger.killAll();
    window.scrollTo(0, 0);

    app();

    conditioner.hydrate(document.documentElement);

    if(window.location.hash) {
        const strate = document.querySelector(window.location.hash);

        if (strate) {
            const stratePosition = strate.getBoundingClientRect().top;
            const offset = 100;
            const offsetPosition = stratePosition + window.pageYOffset - offset;

            window.scrollTo({
                 top: offsetPosition,
                 behavior: "smooth"
            });
        }
    }

    initRecaptchas();
});

barba.hooks.leave(() => {
});

barba.hooks.enter(() => {
    timeline.to(barbaWrap, { opacity: '1', duration: 0.5 });
})

window.barba = barba;

const delay = (n) => {
    return new Promise((done) => {
        setTimeout(() => {
            done();
        }, n)
    })
}

const debounce = (func) => {
    var timer;
    return function(event){
        if(timer) clearTimeout(timer);
        timer = setTimeout(func,100,event);
    };
}

// window.addEventListener("resize",debounce(function(e){
//     marqueeSize.init()
// }));

// Conditioner
conditioner.addPlugin({
    monitor: {
        name: 'visible',
        create: (context, element) => ({
            matches: false,
            addListener(change) {
                new IntersectionObserver((entries) => {
                    this.matches = entries.pop().isIntersecting === context;
                    change();
                }).observe(element);
            },
        }),
    },
    moduleSetName: (name) => `./modules/${name}.js`,
    moduleGetConstructor: (module) => module.default,
    moduleImport: (name) => import(/* webpackMode: "lazy" */ `${name}`),
});

window.conditioner = conditioner;